import { ApiModel } from "./model.model";

export class ApiEvent extends ApiModel {
    // Company: Company;
    // Contact: Contact;
    // Lead: Lead;
    // Deal: Deal;
    // Case: Case;
    company_ID: string;
    contact_ID: string;
    related_type: string;
    related_status: string;
    related_ID: string;
    subject: string;
    type: string;
    sub_type: string;
    priority: string;
    date: string;
    time2: string;
    duration_seconds: string;
    notes: string;
    status: string;
    invitees: string;
    latitude: string;
    longitude: string;
    public_note: string;
    category: string;
    date_type: string;
    reminder_minutes: string;
    // customer_related_Item: any;
}  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/event.model.ts